import { create } from 'zustand';
import LocalStorageSvc, { SELECTED_SITE_KEY } from '../common/localStorageSvc';
import siteData, { EstimatedWaitTime } from '../api/site';
import { ServerResponse } from '../common/types';

export type SelectedSiteType = {
  selectedSiteId: number | null;
  setSelectedSiteId: (id: number | null) => void;
  estimatedWaitTimeInMinutes: number | null;
  updateEstimatedWaitTime: () => void;
};

const selectedSiteId = LocalStorageSvc.load<number>(SELECTED_SITE_KEY);

const useSelectedSite = create<SelectedSiteType>((set, get) => ({
  selectedSiteId: selectedSiteId as number | null,
  setSelectedSiteId: (id: number | null) => {
    const { selectedSiteId } = get();
    if (id && id !== selectedSiteId) {
      LocalStorageSvc.save<number>(SELECTED_SITE_KEY, id);
      set(() => ({ selectedSiteId: id }));
    }
  },
  estimatedWaitTimeInMinutes: null,
  updateEstimatedWaitTime: async () => {
    try {
      const id: number | null = get().selectedSiteId;
      if (id) {
        const result: ServerResponse<EstimatedWaitTime> =
          await siteData.getEstimatedWaitTime(id);
        if (result.data !== null) {
          const data: EstimatedWaitTime = result.data;
          if (!isNaN(data.estimatedWaitTimeInMinutes)) {
            set(() => ({
              estimatedWaitTimeInMinutes: data.estimatedWaitTimeInMinutes,
            }));
          }
        }
      }
    } catch (err) {
      console.error(err);
    }
  },

}));

export default useSelectedSite;
